export enum WhatsAppSettingsTab {
  ADMIN_NOTIFICATIONS = 'adminnotifications',
  CUSTOMER_CONFIRMATIONS = 'customerconfirmations',
  CUSTOMER_REMINDERS = 'customerreminders',
  POST_WORKSHOP = 'postworkshop',
  PICKUP_NOTIFICATIONS = 'pickupnotifications',
}

export const WHATSAPP_SETTINGS_TABS = [
  WhatsAppSettingsTab.ADMIN_NOTIFICATIONS,
  WhatsAppSettingsTab.CUSTOMER_CONFIRMATIONS,
  WhatsAppSettingsTab.CUSTOMER_REMINDERS,
  WhatsAppSettingsTab.POST_WORKSHOP,
  WhatsAppSettingsTab.PICKUP_NOTIFICATIONS,
];

export const MAX_EXTRA_LINES_CHARS = 700;
